import { DictionaryText, ErrorSummaryError, Text } from '../..'
import React, { FC } from 'react'

interface FormErrorListItemProps {
    error: ErrorSummaryError
}

interface FormErrorListItemContentProps {
    error: ErrorSummaryError
}

const FormErrorListItemContent: FC<FormErrorListItemContentProps> = ({ error }) => (
    <Text tag="span">
        {error.fieldNameTranslationKey ? (
            <>
                <DictionaryText textKey={error.fieldNameTranslationKey} />:{' '}
            </>
        ) : undefined}
        {error.errorMessage}
    </Text>
)

/**
 * Renders out an LI html element. The element will be interactive if the html element specified in the provided error is found.
 */
export const FormErrorListItem: FC<FormErrorListItemProps> = ({ error }) => {
    const referencedInputExists = !!document.getElementById(error.formInputId)

    return (
        <li key={error.formInputId}>
            {referencedInputExists ? (
                <a href={`#${error.formInputId}`} className="underline">
                    <FormErrorListItemContent error={error} />
                </a>
            ) : (
                <FormErrorListItemContent error={error} />
            )}
        </li>
    )
}
